import React from 'react';

import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import { toInteger } from 'lodash';

import ContentCard from '../../../components/ContentCard';
import DataGrid from '../../../components/DataGrid';
import { Course } from '../../../services/courses/types';
import { Tutorial } from '../../../services/tutorials/types';

import { ErrorText, SuccessText } from './index.styles';

interface CompletedTutorialsCardProps {
  tutorials: Tutorial[],
  courses: Course[]
}

const CompletedTutorialsCard = ({ tutorials, courses }: CompletedTutorialsCardProps) => (
  <ContentCard variant="outlined" title="Conducted Tutorials">
    {tutorials.length > 0 ? (
      <DataGrid
        rows={tutorials}
        initialState={{
          sorting: {
            sortModel: [{ field: 'startDatetimeIdentifier', sort: 'desc' }],
          },
          pagination: { paginationModel: { pageSize: 5 } },
        }}
        pageSizeOptions={[5]}
        columns={[
          {
            field: 'startDatetimeIdentifier',
            headerName: 'Date',
            width: 80,
            renderCell: (e: any) => {
              const datetime = toInteger(e.value.split('#')[0]);
              return dayjs(datetime).format('D-MMM');
            },
          },
          {
            field: 'course',
            headerName: 'Course',
            width: 160,
            renderCell: (e: any) => courses.find((c) => c.id === e.value)?.label || 'Unknown',
          },
          {
            field: 'duration',
            headerName: 'Duration',
            width: 120,
            renderCell: (e: any) => `${e.value} mins`,
          },
          {
            field: 'state',
            headerName: 'State',
            width: 120,
            valueGetter: ({ row }: any) => (((row?.attendees || []).length > 0) ? 'Conducted' : 'Cancelled'),
            renderCell: ({ row }: any) => (((row?.attendees || []).length > 0) ?
              <SuccessText>Conducted</SuccessText> :
              <ErrorText>Cancelled</ErrorText>),
          },
        ]}
        getRowId={(e) => `${e.startDatetimeIdentifier}`}
      />
    ) : (
      <Typography variant="caption">
        There are no tutorials conducted by this staff member in the selected period.
      </Typography>
    )}
  </ContentCard>
);

export default CompletedTutorialsCard;
